import React, { memo } from "react";
import { Wrap } from "./style";

export default memo(function FooterCpn(props) {
  const { bgColor } = props;
  return (
    <Wrap bgColor={bgColor}>
      <span>© 2021 SINOCHEM all right reserved.</span>
    </Wrap>
  );
});
